import {constructor} from "tsyringe/dist/typings/types";
import {StringHelper} from "../helpers/string.helper";
import {container} from "tsyringe";

export function comparator<T>(type?: constructor<any>): (target: constructor<T>) => void {

    const typeName = type ? StringHelper.toKebabCase(type.name) : `default`;
    const name = `comparator.${typeName}`;

    return function (target: constructor<T>): void {
        if (container.isRegistered(name)) {
            throw new Error(`A comparator is already registered for ${typeName}`);
        }

        container.register(name, target);

        if (type) {
            container.register(type, target);
        }
    }
}